export const CURRENT_SUBSCRIPTION = {
    NO_SUBSCRIPTION: 'You are not subscribed to Tata Play Binge. Choose a plan and start your subscription to enjoy your favourite movies & TV shows. ',
    NO_SUBSCRIPTION_DEACTIVE_USER: 'Recharge to activate your Tata Play Binge subscription.',
    FIRESTICK: 'This plan is linked to your Amazon Fire TV Stick - Tata Play Edition.',
    FIRESTICK_ELIGIBLE: 'Eligible for an Amazon Fire TV Stick - Tata Play Edition',
    ATV_STICK: 'This plan is linked to your Tata Play Binge+.',
    EXPIRES: 'Expires on',
    EXPIRED: 'Expired on',
    ENDS: 'Ends on',
    RENEWAL: 'Renewal on',
    CANCEL_YOUR_SUBSCRIPTION: 'Cancel Subscription',
    CANCEL_SUBSCRIPTION: 'Cancel Subscription',
    RESUME_SUBSCRIPTION: 'Withdraw Cancellation',
    MODIFY_SUBSCRIPTION: 'Modify',
    CANCEL_SUBSCRIPTION_DETAIL: 'Subscription amount will be deducted from your Tata Play balance every 30 days.',
    CANCEL_SUBSCRIPTION_POPUP: 'Are you sure you want to cancel your Subscription?',
    CANCEL_SUBSCRIPTION_POPUP_SUCCESS_PARA: 'Your Binge subscription has been cancelled.',
    RESUME_SUBSCRIPTION_POPUP: 'Are you sure that you want to revoke your cancellation request?',
    RESUME_SUBSCRIPTION_POPUP_SUCCESS: 'Thank you for continuing the subscription',
    RESUME_SUBSCRIPTION_POPUP_SUCCESS_PARA: 'Start enjoying your favourite Movies and TV Shows',
    CANCEL_BINGE_SUBSCRIPTION: 'If you cancel your Binge will also be cancelled.',
    CANCEL_BINGE_PRIME_SUBSCRIPTION: 'If you cancel Tata Play Binge, your Amazon Prime subscription will also be canceled.',
    CANCEL_FTV_COLLECTION: 'Your FTV will be collected back after your Binge subscription ends',
    BILLING_PERIOD: 'Billing Period',
    CANCELLATION_REQUEST_TAKEN: 'Cancellation Request Taken',
    CANCELLATION_ERROR_HEADER: 'The operation couldn’t be completed.',
    RESUME_ERROR_HEADER: 'The operation couldn’t be completed.',
};

export const ACTION = {
    CANCEL_PACK:'CANCEL_PACK',
    RESUME_PACK:'RESUME_PACK',
    CLEAR_DATA:'CLEAR_DATA',
    GET_UPGRADE_TRANSITION_DETAILS: 'GET_UPGRADE_TRANSITION_DETAILS',
};

export const PRIMESTATUS = {
    ACTIVATED:"ACTIVATED",
    CANCELLED:"CANCELLED",
    CANCELLED_INITIATED:"CANCELLED_INITIATED",
}

export const LOGO_DIMENSIONS = {
    width: 82,
    height: 52,
};

export const BASE_PACK_LOGO_DIMENSIONS = {
    width: 95,
    height: 59,
};